<template>
	<div class="contact">
		<mbBanner title="联系我们" />
		<div class="contact-content">
			<div class="contact-us">
				江西通慧科技集团股份有限公司（总部）
			</div>
			<p class="contact-p"><i class="el-icon-message"></i> 电子邮箱：jxth@jxth.com</p>
			<p class="contact-p"><i class="el-icon-phone"></i> 
			联系电话：<a href="tel:0791-86613192">0791-86613192</a> <br/>&nbsp;&nbsp;&nbsp;&nbsp; 传真：0791-83801732 </p>
			<p class="contact-p" style="padding-left: 20px;">
			业务联系：<br/>
			<a href="tel:13814185008">13814185008</a> (戴先生) 结构物健康监测<br/>
			<a href="tel:13387087883">13387087883</a> (林先生) 智慧工地 <br/>
			<a href="tel:13207919992">13207919992</a> (陶先生) 智慧交通</p>
			<p class="contact-p">
				<i class="el-icon-location-information"></i> 
				公司地址：江西省南昌经济技术开发区瑞香路900号通慧科技大厦
			</p>
			<baidu-map class="bm-view" :center="siteStartX" :zoom="13">
				<bm-marker :position="siteStartX" animation="BMAP_ANIMATION_BOUNCE">
					<bm-label
					  content="江西省南昌经济技术开发区<br/>瑞香路900号通慧科技大厦"
					  :offset="{width:20,height:0}"
					  :position="siteStartX"
					  title="江西通慧科技集团股份有限公司"
					/>
				</bm-marker>
			</baidu-map>
			<div class="contact-li">
				<img style="width: 150px;" src="../../assets/img/ercode.jpg" alt="" />
				<p style="color: #999999;font-size: 12px;">长按识别二维码关注官方微信公众号</p>
			</div>
		</div>
	</div>
</template>

<script>
import mbBanner from "./mb_banner.vue";
export default {
  components: {
    mbBanner
  },
  data() {
  	return {
  		siteStartX: { // 经纬度
  		  lng: 115.810222, lat: 28.726292
  		},
  	}
  },
}
</script>

<style lang="scss" scoped>
	//联系我们
	.contact{
		
		.contact-content{
			padding: 20px;
			width: 100%;
			box-sizing: border-box;
			.contact-us{
				font-size: 18px;
				color: #111;
				font-weight: 600;
				margin-bottom: 10px;
			}
			.contact-box{
				margin: auto;
			}
			.contact-li{
				text-align: center;
				margin-top: 10px;
			}
			.contact-p{
				margin-bottom: 10px;
				font-size: 15px;
			}
			.bm-view {
				height: 250px;
			}
		}
	}
</style>
